import React from 'react';
import { Typography, ButtonBase, Icon } from '@material-ui/core';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import { PageWrapper, PageHeader } from 'components';
import { useDeviceInfo } from 'hooks/useDeviceInfo';
import apiSlice from 'services/api';
import { setPage } from 'services/transactions/transactionsSlice';

const StyledTypography = styled(Typography)`
  font-weight: 500;
  font-size: 16px;
  padding: ${(props: any) => (props.isActive ? '23px 13px 20px 13px' : '23px 13px')};
  border-bottom: ${(props: any) => (props.isActive ? '3px solid #212121' : 'none')};
`;

const StyledPageWrapper = styled(PageWrapper)`
  display: flex;
  width: 100%;
  align-items: center;
  @media (max-width: 560px) {
    flex-direction: column;
    > button {
      flex: 1;
      h2 {
        width: 100%;
      }
    }
  }
`;


const allTabs = [
  { name: 'all', title: 'All' },
  { name: 'transactions', title: 'Card Transactions' },
  { name: 'easy_pay', title: 'Easy Pay' },
];

interface HeaderProps {
  currentTab: string;
  changeTab: (tab: string) => void;
}

const Header = ({ currentTab, changeTab }: HeaderProps) => {
  const { isMobile } = useDeviceInfo();
  const dispatch = useDispatch();
  const tabs = isMobile ? allTabs.filter(t => t.name === 'all') : allTabs;

  const handleRefresh = () => {
    dispatch(setPage({ tab: 'all', page: 1 }));
    dispatch(setPage({ tab: 'card', page: 1 }));
    dispatch(setPage({ tab: 'easyPay', page: 1 }));
    dispatch(apiSlice.util.invalidateTags(['BuyerTransactions']));
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <PageHeader>
      <StyledPageWrapper>
        {tabs.map((tab, index) => (
          <ButtonBase onClick={() => changeTab(tab.name)} key={index}>
            <StyledTypography variant="title" isActive={currentTab === tab.name || (currentTab === '' && tab.name === 'all')}>
              {tab.title}
            </StyledTypography>
          </ButtonBase>
        ))}
      </StyledPageWrapper>
      <span style={{ flex: 1 }} />
      <ButtonBase onClick={handleRefresh} aria-label="Refresh">
        <Icon>refresh</Icon>
      </ButtonBase>
    </PageHeader>
  );
};

export default Header;
